module.exports = __webpack_public_path__ + "static/img/s3.e52ad40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s3.png
// module id = QGi1
// module chunks = 1